<script>
  import {calcPercent} from "../../Common/tools";
  import Table from "../../Table/Table.svelte";
  import { onMount } from "svelte";
  import {External, M} from "../../external";
  import {getChannelIcon, hasValidAttachments} from "../../CRM/Popups/messages/common";
  import {getAutomationSalesTotals, getEmailAndMessageSteps, getStepSalesUTM} from "../static";
  import Overview from "./Overview.svelte";
  import Stats from "../../Store/Stats/Stats.svelte";
  import {buildSalesUTMFilters} from "../../Store/static";
  import Users from "./Users.svelte";

  export let data;
  export let backToAll;
  export let previous;
  export let setGoal;

  let tab = "overview", hasSentItems = false, instance;

  let tableData = {
    count: 0,
    columns: [
      { key: "image", type: "image", label: "", class: "flex-none mw-100" },
      {
        key: "name",
        label: M.SUBJECT,
        class: "flex-1 mw-300 ws-normal",
        disableNameInitials: true
      },
      { key: "completed", label: M.AUDIENCE, type: "number", class: "flex-none mw-100" },
      { key: "open", label: M.OPENED, rowClass: "pay-status paid", class: "mw-100" },
      { key: "click", label: M.CLICKED, rowClass: "order-status pending", class: "mw-100" },
      { key: "bounce", label: M.BOUNCED, rowClass: "order-status pending", class: "mw-100" },
      { key: "spam", label: M.SPAM, rowClass: "order-status pending", class: "mw-120" },
      { key: "conversion", label: M.CONVERSION, type: "percent", rowClass: "order-status paid", class: "mw-100 none" }
    ],
    rows: []
  };

  let salesTrackingEnabled = false;     //at least one step has sales tracking enabled
  let showFlowSalesTotalsCols = true;   //include the sales totals columns in the flow table
  let salesTabFilters, funnelId, activePeriod;  //Sales tab params
  let query = "";

  onMount(async function () {
    let stepUtms;

    const steps = getEmailAndMessageSteps(data.flow.steps);

    for (const step of steps) {

      if (step.type === "SEND_EMAIL") {
        step.image = getThumb(step);
        step.open = calcPercent(step.opened, step.sent);
        step.click = calcPercent(step.clicked, step.sent);
        step.bounce = calcPercent(step.bounced, step.sent);
        step.spam = calcPercent(step.complaints, step.sent);
        hasSentItems = hasSentItems || step.sent > 0;
      } else {
        step.image = getMessageThumb(step);
        step.open = "-";
        step.click = "-";
        step.bounce = "-";
        step.spam = "-";
        hasSentItems = hasSentItems || step.completed > 0;
      }

      step.orders = "-";
      step.sales = "-";

      let stepUtm = getStepSalesUTM(step);

      if (stepUtm) {

        if (!salesTrackingEnabled) {
          stepUtms = [];
          initSalesTrackingVars();
        }

        if (stepUtms.includes(stepUtm)) {   //some steps may have identical UTM params, so dont count them twice
          showFlowSalesTotalsCols = false;  //only show the sales totals in the Message Flow table if each step has unique UTM params
        } else {
          stepUtms[stepUtms.length] = stepUtm;
          const stepTotals = await getAutomationSalesTotals(data, stepUtm);
          step.sales = External.Tools.currencyToStrWithSymbol(stepTotals.sales);
          step.orders = stepTotals.orders;
        }
      }
    }

    if (salesTrackingEnabled) {
      if (showFlowSalesTotalsCols) {
        tableData.columns.push({key: "sales", label: M.SALES, type: "text", class: "mw-100"});
        tableData.columns.push({key: "orders", label: M.ORDERS, type: "text", class: "mw-100"});
      }

      salesTabFilters = buildSalesUTMFilters(...stepUtms);
    }

    tableData = Object.assign({}, tableData, {rows: steps});

  });

  function getThumb(step) {
    let thumb = (step.settings || []).filter(setting => setting.key === "thumb")[0];
    if (thumb) {
      return External.content + thumb.value;
    } else {
      return External.getThumbnailsFromBase(External.getUserDir(), "emails") + data.id + "_" + step.id + ".png" + "?v=deprecated-thumb";
    }
  }

  function getMessageThumb(step) {
    let message = JSON.parse(step.settings[0].value);
    if (message.channel === External.CRM_MESSAGE_CHANNEL.WHATSAPP && hasValidAttachments(message)) {
      return External.getFileFromBase(message.attachments[0].base) + message.attachments[0].name + "?format=webp";
    } else {
      return getChannelIcon(message.channel);
    }
  }

  function switchTab(t) {
    tab = t;
  }

  function initSalesTrackingVars() {
    salesTabFilters = [[]];
    activePeriod = {
      label: M.LAST_SEVEN_DAYS,
      id: "7-days",
      from: new Date(data.modified.epochSecond * 1000),
      to: new Date() //now
    };

    funnelId = External.Website.getActiveFunnel()?.id;
    salesTrackingEnabled = true;
  }

  let search = External.$.debounce(250, function () {
    instance.reloadData();
  });

</script>

<div class="flex-1 overflow account-settings col20 store-products scrollable-settings">
  <div class="inner-wrapper members-table-wrapper">
    <div class="top-background-wrapper narrow-top-background" style="padding-top: 30px;">
      <div class="top-background">
        <div class="text-wrapper flex align-center flex-col">
          <a on:click={backToAll} rel="action" data-action="back" class="back-to-next-step none" style="margin-bottom: 8px;">&larr; {M.BACK_TO_ALL_AUTOMATIONS}</a>
          <div class="col20 flex align-center">
            <div class="flex-1">
              <span class="col20 f-left t-left"><h1 class="members-title f-left" style="margin-bottom: 0;">{data.name}</h1></span>
              <span class="col20 f-left t-left" style="opacity: .7; color: #fff; font-size: 15px;">
                {M.MODIFIED_ON}
                {External.Tools.dateToString(new Date(data.modified.epochSecond * 1000), true, true)}
              </span>
            </div>
            <div class="f-right mr-5 search-outer-wrapper" class:none={tab !== "users"}>
              <input type="text" name="q" bind:value={query} on:keyup={search} class="search-input border-type-all" placeholder={M.SEARCH_USERS_BY_NAME_EMAIL} />
              <span class="material-icons"> search </span>
            </div>
            <a on:click={previous} class="blue middle-button f-right flex-none">{M.EDIT_AUTOMATION_FLOW}</a>
          </div>
        </div>
      </div>
    </div>

    <div class="content-wrapper members-content-wrapper">
      <div class="sections-wrapper members-wrapper email-campaign-wrapper">
        <ul class="upper-navigation upper-navigation-full">
          <li><a on:click|preventDefault={() => switchTab("overview")} class:active={tab === "overview"}>{M.OVERVIEW}</a></li>
          {#if salesTrackingEnabled}
            <li><a on:click|preventDefault={() => switchTab("sales")} class:active={tab === "sales"}>{M.SALES}</a></li>
          {/if}
          <li><a on:click|preventDefault={() => switchTab("users")} class:active={tab === "users"}>{M.CONTACTS}</a></li>
        </ul>
        {#if tab === "overview"}
          <Overview bind:this={instance} bind:data {setGoal} {hasSentItems} />
        {:else if tab === "sales"}
          <Stats bind:this={instance} filters={salesTabFilters} period={activePeriod} funnelId={funnelId} />
        {:else if tab === "users"}
          <Users bind:this={instance} bind:data bind:query {setGoal} />
        {/if}
      </div>

      {#if tab !== "users"}
        <div class="sections-wrapper members-wrapper email-campaign-wrapper" style="margin-top: 25px;">
          <h2 class="col20 f-left f-28 gray-text mt-25 mb-25">
            {M.FLOW_EMAILS_MESSAGES}
          </h2>
          <Table activeColumns={tableData.columns} data={tableData.rows} hasSelection={false} />
        </div>
      {/if}
    </div>
  </div>
</div>
